import { Card, CardActions, CardContent, CircularProgress, Typography } from "@mui/material"
import React from "react"
import SimpleTable from "../../components/Common/Elements"
import { useGetTohUserProfileQuery } from "../../core/api/toh-user-api"
import { format } from "date-fns"
import TohAvatarChangeBlockControl from "./TohAvatarChangeBlockControl"
import TohAvatarChangeUnblockControl from "./TohAvatarChangeUnblockControl"

const TohAvatarChangeBlockStatusCard = ({ userId }) => {
    const { data: profile, isLoading, isFetching } = useGetTohUserProfileQuery(
        userId,
        { skip: userId === "" }
    )

    const blockedUntil = profile?.avatarChangeBlockedUntilSeconds ?? null
    const isBlocked = blockedUntil != null && new Date(blockedUntil * 1000) > new Date()
    const blockedUntilDate = isBlocked ? new Date(blockedUntil * 1000) : null

    return (
        <Card>
            <CardContent>
                <Typography
                    sx={{
                        pb: 2,
                        fontSize: 16
                    }}>
                    Avatar Change Block
                </Typography>
                {
                    isLoading || isFetching
                        ? (
                            <CircularProgress />
                        )
                        : (
                            <SimpleTable
                                data={[
                                    ["Blocked", isBlocked ? "Yes" : "No"],
                                    ["Until", blockedUntilDate ? format(blockedUntilDate, "dd MMM yyyy HH:mm") : "N/A"]
                                ]}
                            />
                        )
                }
            </CardContent>
            <CardActions>
                <TohAvatarChangeBlockControl disabled={isLoading || isFetching} userId={userId} />
                <TohAvatarChangeUnblockControl disabled={isLoading || isFetching} userId={userId} />
            </CardActions>
        </Card>
    );
}

export default TohAvatarChangeBlockStatusCard
